import './Testimonials.css'

const Testimonials = () => {
  return (
    <section id="stories" className="stories">
      <div className="stories-layout">
        <figure className="stories-portrait">
          <img
            src="/gallery2.jpg"
            alt="A grandmother and grandchild resting together in a field of daisies"
          />
          <figcaption>Love, kept close.</figcaption>
        </figure>
        <div className="stories-quotes">
          <span className="section-eyebrow">In their words</span>
          <h2>Stories of peace</h2>
          <blockquote>
            <p>When my mother passed, Echo saved us weeks of searching and helped us focus on what really mattered — remembering her.</p>
            <footer>Angela, North Carolina</footer>
          </blockquote>
          <blockquote>
            <p>Echo gave me peace knowing my children won&apos;t struggle to find what they need.</p>
            <footer>James, Virginia</footer>
          </blockquote>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
